"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4578],{

/***/ 94254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ form_EditVendorForm; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/components/Mutation.js
var Mutation = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/link.js
var next_link = __webpack_require__(54892);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/router.js
var next_router = __webpack_require__(22051);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-final-form@6.5.9_s44h3cxpdxv6cks4bnqewerqda/node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(56225);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
// EXTERNAL MODULE: ./lib/hooks/useIntlValidationMessages.ts
var useIntlValidationMessages = __webpack_require__(67308);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
// EXTERNAL MODULE: ./lib/queries/fragments/VendorFields.ts
var VendorFields = __webpack_require__(31453);
;// CONCATENATED MODULE: ./lib/mutations/EditVendor.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation EditVendor($id: ObjectId!, $vendor: VendorInput!) {\n    editVendor(id: $id, vendor: $vendor) {\n      _id\n      ...VendorFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var EditVendor = ((0,lib/* gql */.Ps)(_templateObject(), VendorFields/* default */.Z));

// EXTERNAL MODULE: ./lib/utils/validate.ts
var validate = __webpack_require__(32774);
// EXTERNAL MODULE: ./types/types.ts
var types = __webpack_require__(43845);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
;// CONCATENATED MODULE: ./components/form/PreviewModal.tsx




function PreviewModal(param) {
    var isOpen = param.isOpen, onClose = param.onClose, header = param.header, text = param.text, onPreviewBasicClick = param.onPreviewBasicClick, onPreviewMakersClick = param.onPreviewMakersClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Modal */.u_, {
        isOpen: isOpen,
        onClose: onClose,
        closeOnEsc: false,
        closeOnOverlayClick: false,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* ModalOverlay */.ZA, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* ModalContent */.hz, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* ModalHeader */.xB, {
                        textAlign: "center",
                        children: header
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* ModalBody */.fe, {
                        textAlign: "center",
                        children: text
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* ModalFooter */.mz, {
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
                            direction: "row",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                                    variantColor: "blue",
                                    onClick: onPreviewBasicClick,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Continue as Basic",
                                        id: "PdBd+0"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                                    variantColor: "teal",
                                    ml: 2,
                                    onClick: onPreviewMakersClick,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Preview as Makers",
                                        id: "qbrGOa"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/spacings.tsx
var spacings = __webpack_require__(52126);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp.js
var fp = __webpack_require__(56365);
var fp_default = /*#__PURE__*/__webpack_require__.n(fp);
// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(55423);
// EXTERNAL MODULE: ./lib/utils/prefixWithHttpIfNecessary.ts
var prefixWithHttpIfNecessary = __webpack_require__(6525);
;// CONCATENATED MODULE: ./lib/utils/urlRegex.ts
// Do not require http or https
/* harmony default export */ var urlRegex = (/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/);

;// CONCATENATED MODULE: ./components/vendor/form/convertValuesToVariables.ts




function convertValuesToVariables(values) {
    return {
        name: values.name || null,
        billingName: values.billingName || null,
        description: values.description || null,
        yearFounded: Number(values.yearFounded) || null,
        site: (0,prefixWithHttpIfNecessary/* default */.Z)(values.site),
        headquarters: values.headquarters || null,
        slogan: values.slogan || null,
        contactPage: getContactPage(values.contact) || null,
        businessEmail: getBusinessEmail(values.contact) || null,
        highlights: fp_default().uniq(values.highlights.map((fp_default()).trim).filter(Boolean)) || null,
        newsworthy: values.newsworthy || null,
        logo: values.logo || null,
        socialMedia: fp_default().pick([
            "facebook",
            "instagram",
            "linkedin",
            "twitter",
            "youtube"
        ], values.socialMedia) || null,
        numberOfEmployees: fp_default().get("numberOfEmployees.value", values) || null,
        cover: null,
        resources: (values.resources || []).map((0,fp.pick)([
            "type",
            "url",
            "title",
            "body"
        ]))
    };
};
function getContactPage(contact) {
    if (!contact) {
        return null;
    }
    var urlSchema = es/* string */.Z_().matches(urlRegex);
    try {
        urlSchema.validateSync(contact);
        return (0,prefixWithHttpIfNecessary/* default */.Z)(contact);
    } catch (e) {
        return null;
    }
}
function getBusinessEmail(contact) {
    if (!contact) {
        return null;
    }
    var emailSchema = es/* string */.Z_().email();
    try {
        emailSchema.validateSync(contact);
        return contact;
    } catch (e) {
        return null;
    }
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
;// CONCATENATED MODULE: ./components/vendor/form/convertVendorToInitialValues.ts


function convertVendorToInitialValues(vendor) {
    var values = {
        _id: vendor._id,
        name: vendor.name,
        billingName: vendor.billingName,
        description: vendor.description,
        yearFounded: vendor.yearFounded,
        site: vendor.site,
        headquarters: vendor.headquarters,
        slogan: vendor.slogan,
        contact: getContact(vendor),
        highlights: vendor.highlights,
        newsworthy: vendor.newsworthy.map(function(newsworthy) {
            return {
                url: newsworthy.url,
                title: newsworthy.title,
                siteName: newsworthy.siteName,
                description: newsworthy.description,
                favicon: newsworthy.favicon
            };
        }),
        logo: vendor.logo,
        socialMedia: vendor.socialMedia,
        numberOfEmployees: vendor.numberOfEmployees ? {
            value: vendor.numberOfEmployees,
            label: vendor.numberOfEmployees
        } : null,
        resources: (vendor.resources || []).map(function(resource) {
            if (resource.__typename === "TextResource") {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, resource), {
                    type: "text"
                });
            }
            if (resource.__typename === "DownloadResource") {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, resource), {
                    type: "download"
                });
            }
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, resource), {
                type: "link"
            });
        })
    };
    return values;
};
function getContact(vendor) {
    if (vendor.contactPage) {
        return vendor.contactPage;
    }
    if (vendor.businessEmail) {
        return vendor.businessEmail;
    }
    return "";
}

;// CONCATENATED MODULE: ./components/vendor/form/hasMakersContent.ts
/*
  "numberOfEmployees",
  "headquarters",
  "slogan",
  "contact",
  "socialMedia",
  "resources",
  "highlights",
  "newsworthy",
*/ function hasMakersContent(values) {
    if (values["numberOfEmployees"] !== null) {
        return true;
    }
    if (values["headquarters"]) {
        return true;
    }
    if (values["slogan"]) {
        return true;
    }
    if (values["socialMedia"] && (values["socialMedia"]["facebook"] || values["socialMedia"]["instagram"] || values["socialMedia"]["linkedin"] || values["socialMedia"]["twitter"] || values["socialMedia"]["youtube"])) {
        return true;
    }
    if (Array.isArray(values["resources"]) && values["resources"].length > 0) {
        return true;
    }
    if (Array.isArray(values["highlights"]) && values["highlights"].length > 0) {
        return true;
    }
    if (Array.isArray(values["newsworthy"]) && values["newsworthy"].length > 0) {
        return true;
    }
    return false;
}

;// CONCATENATED MODULE: ./components/vendor/form/validation.ts


/* harmony default export */ function validation(intlValidationMessages) {
    return es/* object */.Ry({
        name: es/* string */.Z_().transform(ensureFilledString).required(intlValidationMessages.cantBeBlank),
        billingName: es/* string */.Z_().nullable(),
        description: es/* string */.Z_().transform(ensureFilledString).required(intlValidationMessages.cantBeBlank),
        yearFounded: es/* number */.Rx().required(intlValidationMessages.cantBeBlank).min(1500, intlValidationMessages.invalidYear).max(new Date().getFullYear(), intlValidationMessages.invalidYear),
        site: es/* string */.Z_().transform(ensureFilledString).required(intlValidationMessages.cantBeBlank).matches(urlRegex, intlValidationMessages.invalidUrl),
        contact: es/* string */.Z_().test({
            message: intlValidationMessages.invalidEmailAddress,
            test: function(value) {
                if (!value) {
                    return true;
                }
                var urlSchema = es/* string */.Z_().matches(urlRegex);
                var emailSchema = es/* string */.Z_().email();
                var validUrl;
                var validEmail;
                try {
                    urlSchema.validateSync(value);
                    validUrl = true;
                } catch (e) {
                    validUrl = false;
                }
                try {
                    emailSchema.validateSync(value);
                    validEmail = true;
                } catch (e1) {
                    validEmail = false;
                }
                return validEmail || validUrl;
            }
        }),
        socialMedia: es/* object */.Ry({
            linkedin: es/* string */.Z_().url(intlValidationMessages.invalidUrl).nullable(),
            twitter: es/* string */.Z_().url(intlValidationMessages.invalidUrl).nullable(),
            facebook: es/* string */.Z_().url(intlValidationMessages.invalidUrl).nullable(),
            instagram: es/* string */.Z_().url(intlValidationMessages.invalidUrl).nullable(),
            youtube: es/* string */.Z_().url(intlValidationMessages.invalidUrl).nullable()
        }).nullable()
    });
};
function ensureFilledString(maybeFilled) {
    if (!maybeFilled) {
        return "";
    }
    if (maybeFilled.trim().length === 0) {
        return "";
    }
    return maybeFilled;
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+core@0.21.2_iyni55cf3gelv6eahxhjaprhn4/node_modules/@govlaunch/core/index.js + 20 modules
var core = __webpack_require__(98973);
// EXTERNAL MODULE: ./components/form/HighlightsInputField.tsx + 1 modules
var HighlightsInputField = __webpack_require__(23158);
// EXTERNAL MODULE: ./components/form/NewsworthyField.tsx + 1 modules
var NewsworthyField = __webpack_require__(78949);
// EXTERNAL MODULE: ./components/form/sections/Section.tsx
var Section = __webpack_require__(5974);
// EXTERNAL MODULE: ./components/form/sections/SectionBody.tsx
var SectionBody = __webpack_require__(32190);
// EXTERNAL MODULE: ./components/form/sections/SectionHeader.tsx
var SectionHeader = __webpack_require__(73634);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(49980);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+select@0.33.1_3s36zatsal5pm5ktsv6lgzncae/node_modules/@govlaunch/select/index.js + 44 modules
var _govlaunch_select = __webpack_require__(3104);
// EXTERNAL MODULE: ./components/form/FieldValidationError.tsx
var FieldValidationError = __webpack_require__(80360);
// EXTERNAL MODULE: ./components/TwoPassRender.ts
var TwoPassRender = __webpack_require__(52947);
;// CONCATENATED MODULE: ./components/vendor/form/fields/EmployeesNumberField.tsx












function EmployeesNumberField() {
    var intl = (0,useIntl/* default */.Z)();
    var selectOptions = [
        {
            label: intl.formatMessage({
                defaultMessage: "Not specified",
                id: "Rk7UyM"
            }),
            value: null
        }, 
    ].concat((0,_to_consumable_array/* default */.Z)([
        "1 - 10",
        "11 - 50",
        "51 - 100",
        "101 - 500",
        "500+"
    ].map(function(value) {
        return {
            label: value,
            value: value
        };
    })));
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
        name: "numberOfEmployees",
        children: function(param) {
            var input = param.input, meta = param.meta;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            display: "flex",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("label", {
                                css: {
                                    fontWeight: 500,
                                    fontSize: 14,
                                    color: palette/* mediumGray */.rF,
                                    margin: 0
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Number of Employees",
                                    id: "T5WLzg"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FieldValidationError/* default */.Z, {
                                meta: meta
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                        mt: 8,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TwoPassRender/* default */.Z, {
                            children: function() {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_govlaunch_select/* Select */.Ph, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, input), {
                                    items: selectOptions,
                                    placeholder: intl.formatMessage({
                                        defaultMessage: "Select the number of employees",
                                        id: "J6IRZ1"
                                    })
                                }));
                            }
                        })
                    })
                ]
            });
        }
    });
}

// EXTERNAL MODULE: ./components/form/sections/SectionHeaderMakers.tsx
var SectionHeaderMakers = __webpack_require__(63615);
// EXTERNAL MODULE: ./lib/mutations/SetProfileCover.tsx + 1 modules
var SetProfileCover = __webpack_require__(76198);
// EXTERNAL MODULE: ./components/cover/Cover.tsx + 3 modules
var Cover = __webpack_require__(42607);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/getOr.js
var getOr = __webpack_require__(62076);
var getOr_default = /*#__PURE__*/__webpack_require__.n(getOr);
// EXTERNAL MODULE: ./components/form/StickyFooter.tsx
var StickyFooter = __webpack_require__(89493);
// EXTERNAL MODULE: ./components/form/SocialMediaFields.tsx + 2 modules
var SocialMediaFields = __webpack_require__(38011);
// EXTERNAL MODULE: ./components/form/TextField.tsx
var TextField = __webpack_require__(63259);
// EXTERNAL MODULE: ./components/form/TextareaField.tsx
var TextareaField = __webpack_require__(75150);
// EXTERNAL MODULE: ./components/form/UrlField.tsx
var UrlField = __webpack_require__(50523);
// EXTERNAL MODULE: ./components/form/ResourcesField.tsx + 8 modules
var ResourcesField = __webpack_require__(65504);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+profile-picture@1.4.1/node_modules/@govlaunch/profile-picture/index.js + 1 modules
var profile_picture = __webpack_require__(77876);
;// CONCATENATED MODULE: ./components/vendor/form/fields/VendorLogoField.tsx







function VendorLogoField(param) {
    var vendorName = param.vendorName;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
        name: "logo",
        children: function(param) {
            var input = param.input;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Filestack */.QZ, {
                onSuccess: function(param) {
                    var filesUploaded = param.filesUploaded;
                    return input.onChange(filesUploaded[0].url);
                },
                customRender: function(param) {
                    var onPick = param.onPick;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: {
                                    display: "flex",
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                    xlarge: true,
                                    image: input.value,
                                    name: vendorName || "A B"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    display: "grid",
                                    gridAutoFlow: "column",
                                    gridAutoColumns: "max-content",
                                    justifyContent: "center",
                                    gridColumnGap: 5,
                                    marginTop: 16
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                        size: "xsmall",
                                        color: palette/* primary */.T$,
                                        onClick: onPick,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Upload",
                                            id: "p4N05H"
                                        })
                                    }),
                                    input.value && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                        size: "xsmall",
                                        color: palette/* red */.Q6,
                                        theme: "secondary",
                                        css: {
                                            background: "#fff"
                                        },
                                        onClick: function() {
                                            return input.onChange(null);
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Remove",
                                            id: "G/yZLu"
                                        })
                                    })
                                ]
                            })
                        ]
                    });
                }
            });
        }
    });
};

// EXTERNAL MODULE: ./components/form/NumberField.tsx
var NumberField = __webpack_require__(17463);
;// CONCATENATED MODULE: ./components/vendor/form/VendorForm.tsx
























var VendorForm = function(param) {
    var vendor = param.vendor, onSubmit = param.onSubmit, submitting = param.submitting, submitButtonText = param.submitButtonText;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SetProfileCover/* default */.Z, {
                        entityType: "Company",
                        targetId: vendor._id,
                        children: function(param) {
                            var onSetProfileCover = param.onSetProfileCover, onSetRepositionedCover = param.onSetRepositionedCover, onRemoveCover = param.onRemoveCover;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cover/* default */.ZP, {
                                alt: "Cover",
                                height: 250,
                                originalSource: getOr_default()(null, "cover.original", vendor),
                                repositionedSource: getOr_default()(null, "cover.repositioned", vendor),
                                placeholderSource: Cover/* PLACEHOLDER_COVER */.t2,
                                onReposition: function(originalSource, cropState) {
                                    var repositionedSource = (0,Cover/* makeImaginaryUrls */.oH)(originalSource, cropState);
                                    onSetRepositionedCover(originalSource, repositionedSource.cropped, cropState);
                                },
                                onChange: onSetProfileCover,
                                onRemove: onRemoveCover,
                                readOnly: !vendor.viewerIsMember,
                                containerProps: {
                                    style: {
                                        borderRadius: 5,
                                        overflow: "hidden"
                                    }
                                }
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            position: "absolute",
                            top: "50%",
                            marginTop: -30,
                            left: "50%",
                            transform: "translate(-50%, -50%)"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* FormSpy */.lP, {
                            subscription: {
                                values: true
                            },
                            children: function(param) {
                                var values = param.values;
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorLogoField, {
                                    vendorName: values.name
                                });
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    "& > div": {
                        marginTop: 20
                    }
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionHeader/* default */.Z, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "The Basics",
                                    id: "5L4CQD"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionBody/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextField/* default */.Z, {
                                        fieldName: "name",
                                        label: intl.formatMessage({
                                            defaultMessage: "Name",
                                            id: "HAlOn1"
                                        }),
                                        placeholder: intl.formatMessage({
                                            defaultMessage: "Type vendor name",
                                            id: "VOkTGq"
                                        }),
                                        "aria-label": intl.formatMessage({
                                            defaultMessage: "Vendor name",
                                            id: "7GHATk"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextField/* default */.Z, {
                                        fieldName: "billingName",
                                        label: intl.formatMessage({
                                            defaultMessage: "Billing Name",
                                            id: "9CSOR+"
                                        }),
                                        placeholder: intl.formatMessage({
                                            defaultMessage: "Type vendor billing name",
                                            id: "BPybV6"
                                        }),
                                        "aria-label": intl.formatMessage({
                                            defaultMessage: "Billing Name",
                                            id: "9CSOR+"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextareaField/* default */.Z, {
                                        fieldName: "description",
                                        label: intl.formatMessage({
                                            defaultMessage: "Description",
                                            id: "Q8Qw5B"
                                        }),
                                        placeholder: intl.formatMessage({
                                            defaultMessage: "Type vendor description",
                                            id: "uB2OE7"
                                        }),
                                        characterLimit: 240,
                                        "aria-label": intl.formatMessage({
                                            defaultMessage: "Vendor description",
                                            id: "7FxVks"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NumberField/* default */.Z, {
                                        fieldName: "yearFounded",
                                        label: intl.formatMessage({
                                            defaultMessage: "Year Founded",
                                            id: "ccKFl8"
                                        }),
                                        placeholder: intl.formatMessage({
                                            defaultMessage: "Type Year",
                                            id: "HxsQY1"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UrlField/* default */.Z, {
                                        fieldName: "site",
                                        label: intl.formatMessage({
                                            defaultMessage: "Site",
                                            id: "pYwSd7"
                                        }),
                                        placeholder: intl.formatMessage({
                                            defaultMessage: "Type vendor site",
                                            id: "Fmid4X"
                                        }),
                                        "aria-label": intl.formatMessage({
                                            defaultMessage: "Vendor site",
                                            id: "TkZjxS"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionHeaderMakers/* default */.Z, {
                                target: vendor.isDisruptor ? "DISRUPTOR" : "MAKERS",
                                disruptorTooltip: intl.formatMessage({
                                    defaultMessage: "This will display because you're a Disruptor",
                                    id: "ZL6pcN"
                                }),
                                makersTooltip: intl.formatMessage({
                                    defaultMessage: "Your account must be Makers for this to appear",
                                    id: "lvHUQf"
                                }),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "More Info",
                                    id: "vWe94i"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionBody/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmployeesNumberField, {}),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextField/* default */.Z, {
                                        fieldName: "headquarters",
                                        label: intl.formatMessage({
                                            defaultMessage: "Headquarters",
                                            id: "kFQl9u"
                                        }),
                                        placeholder: intl.formatMessage({
                                            defaultMessage: "Type vendor headquarters",
                                            id: "3Dlk3F"
                                        }),
                                        characterLimit: 240,
                                        "aria-label": intl.formatMessage({
                                            defaultMessage: "Vendor headquarters",
                                            id: "ga/Gdu"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextField/* default */.Z, {
                                        fieldName: "slogan",
                                        label: intl.formatMessage({
                                            defaultMessage: "Slogan",
                                            id: "mgRuC7"
                                        }),
                                        placeholder: intl.formatMessage({
                                            defaultMessage: "Type your vendor slogan",
                                            id: "a9g+eH"
                                        }),
                                        characterLimit: 180,
                                        "aria-label": intl.formatMessage({
                                            defaultMessage: "Vendor slogan",
                                            id: "u43UNX"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextField/* default */.Z, {
                                        fieldName: "contact",
                                        label: intl.formatMessage({
                                            defaultMessage: "Contact",
                                            id: "zFegDD"
                                        }),
                                        placeholder: intl.formatMessage({
                                            defaultMessage: "Type a URL or email for contact",
                                            id: "sf7Cnb"
                                        }),
                                        "aria-label": intl.formatMessage({
                                            defaultMessage: "Vendor contact URL or email",
                                            id: "qf4MsP"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionHeaderMakers/* default */.Z, {
                                target: vendor.isDisruptor ? "DISRUPTOR" : "MAKERS",
                                disruptorTooltip: intl.formatMessage({
                                    defaultMessage: "This will display because you're a Disruptor",
                                    id: "ZL6pcN"
                                }),
                                makersTooltip: intl.formatMessage({
                                    defaultMessage: "Your account must be Makers for this to appear",
                                    id: "lvHUQf"
                                }),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Social Media",
                                    id: "5bGX59"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionBody/* default */.Z, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialMediaFields/* default */.Z, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionHeaderMakers/* default */.Z, {
                                target: vendor.isDisruptor ? "DISRUPTOR" : "MAKERS",
                                disruptorTooltip: intl.formatMessage({
                                    defaultMessage: "This will display because you're a Disruptor",
                                    id: "ZL6pcN"
                                }),
                                makersTooltip: intl.formatMessage({
                                    defaultMessage: "Your account must be Makers for this to appear",
                                    id: "lvHUQf"
                                }),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Resources",
                                    id: "c/KktL"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionBody/* default */.Z, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResourcesField/* default */.Z, {
                                    fieldName: "resources"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionHeaderMakers/* default */.Z, {
                                target: vendor.isDisruptor ? "DISRUPTOR" : "MAKERS",
                                disruptorTooltip: intl.formatMessage({
                                    defaultMessage: "This will display because you're a Disruptor",
                                    id: "ZL6pcN"
                                }),
                                makersTooltip: intl.formatMessage({
                                    defaultMessage: "Your account must be Makers for this to appear",
                                    id: "lvHUQf"
                                }),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Highlights",
                                    id: "KGmQjH"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightsInputField/* default */.Z, {
                                fieldName: "highlights"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionHeaderMakers/* default */.Z, {
                                target: vendor.isDisruptor ? "DISRUPTOR" : "MAKERS",
                                disruptorTooltip: intl.formatMessage({
                                    defaultMessage: "This will display because you're a Disruptor",
                                    id: "ZL6pcN"
                                }),
                                makersTooltip: intl.formatMessage({
                                    defaultMessage: "Your account must be Makers for this to appear",
                                    id: "lvHUQf"
                                }),
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Newsworthy",
                                    id: "JhItYg"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsworthyField/* default */.ZP, {
                                fieldName: "newsworthy"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StickyFooter/* default */.Z, {
                css: {
                    marginTop: 16
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        padding: 16,
                        display: "grid",
                        gridTemplateColumns: "repeat(2, 1fr)",
                        gridColumnGap: 20
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                            onClick: function() {
                                return history.back();
                            },
                            color: palette/* red */.Q6,
                            theme: "secondary",
                            size: "large",
                            type: "button",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Cancel",
                                id: "47FYwb"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Button */.zx, {
                            size: "large",
                            color: palette/* greenSuccess */.CU,
                            textColor: "#fff",
                            type: "submit",
                            disabled: submitting,
                            css: {
                                ":disabled": {
                                    background: "rgba(0, 0, 0, 0.2)"
                                }
                            },
                            children: [
                                submitButtonText || intl.formatMessage({
                                    defaultMessage: "Save",
                                    id: "jvo0vs"
                                }),
                                submitting && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        marginLeft: 10
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* LoadingIndicator */.TF, {})
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var form_VendorForm = (VendorForm);

;// CONCATENATED MODULE: ./components/vendor/form/EditVendorForm.tsx



















var EditVendorForm = function(param) {
    var vendor = param.vendor;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)(false), isModalOpen = ref[0], setIsModalOpen = ref[1];
    var initialValues = convertVendorToInitialValues(vendor);
    var intlValidationMessages = (0,useIntlValidationMessages/* default */.Z)();
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                mb: 16,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: "/vendors/[vendorSlug]",
                        as: "/vendors/".concat(vendor.slug),
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                            css: {
                                fontSize: 16,
                                color: palette/* innovatorBlue */.LD,
                                ":hover": {
                                    textDecoration: "underline !important"
                                }
                            },
                            children: [
                                "← ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Leave Editor",
                                    id: "Vp9Im5"
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                mutation: EditVendor,
                children: function(editVendor) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Form */.l0, {
                        subscription: {
                            submitting: true
                        },
                        initialValues: initialValues,
                        keepDirtyOnReinitialize: true,
                        validate: (0,validate/* default */.Z)(validation(intlValidationMessages)),
                        onSubmit: function(values) {
                            var makersContent = hasMakersContent(values);
                            return editVendor({
                                variables: {
                                    id: vendor._id,
                                    vendor: convertValuesToVariables(values)
                                }
                            }).then(function(mutationResult) {
                                if (mutationResult && mutationResult.data && mutationResult.data.editVendor && mutationResult.data.editVendor.slug) {
                                    if (makersContent && mutationResult.data.editVendor.plan.tier === types/* IPlanTier.Basic */.fq.Basic) {
                                        setIsModalOpen(true);
                                        return;
                                    }
                                    if (mutationResult.data.editVendor.plan.tier === types/* IPlanTier.Basic */.fq.Basic) {
                                        router.push("/vendors/[vendorSlug]", "/vendors/".concat(mutationResult.data.editVendor.slug, "?preview=1"));
                                    } else {
                                        router.push("/vendors/[vendorSlug]", "/vendors/".concat(mutationResult.data.editVendor.slug, "?preview=1&makers=1"));
                                    }
                                }
                            });
                        },
                        children: function(param) {
                            var handleSubmit = param.handleSubmit, submitting = param.submitting, invalid = param.invalid;
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PreviewModal, {
                                        isOpen: isModalOpen && !invalid,
                                        onClose: function() {
                                            return setIsModalOpen(false);
                                        },
                                        header: intl.formatMessage({
                                            defaultMessage: "Profile Saved!",
                                            id: "U4nXgh"
                                        }),
                                        text: intl.formatMessage({
                                            defaultMessage: "Some of the information you’ve added will only show for accounts upgraded to Makers.",
                                            id: "vNBw6T"
                                        }),
                                        onPreviewBasicClick: function() {
                                            return router.push("/vendors/[vendorSlug]", "/vendors/".concat(vendor.slug, "?preview=1"));
                                        },
                                        onPreviewMakersClick: function() {
                                            return router.push("/vendors/[vendorSlug]", "/vendors/".concat(vendor.slug, "?preview=1&makers=1"));
                                        }
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(form_VendorForm, {
                                        vendor: vendor,
                                        submitting: submitting,
                                        onSubmit: handleSubmit,
                                        initialVendorName: String(initialValues.name)
                                    })
                                ]
                            });
                        }
                    });
                }
            })
        ]
    });
};
/* harmony default export */ var form_EditVendorForm = (EditVendorForm);


/***/ }),

/***/ 93849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18125);
/* harmony import */ var _lib_queries_fragments_VendorFields__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31453);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query Vendor($slug: String!, $language: String) {\n    company(slug: $slug, language: $language) {\n      _id\n      ...VendorFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject(), _lib_queries_fragments_VendorFields__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z));


/***/ }),

/***/ 31453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17440);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18125);
/* harmony import */ var _lib_queries_fragments_CompanyPlanFields__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28896);
/* harmony import */ var _govlaunch_project__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78062);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment VendorFields on Company {\n    _id\n    logo\n    slug\n    name\n    billingName\n    logo\n    description\n    yearFounded\n    createdAt\n    businessEmail\n    site\n    viewerIsMember\n    isDisruptor\n    address\n    contactPage\n    highlights\n    viewerCanInviteMembers\n    viewerCanRemoveMembers\n    slogan\n    headquarters\n    numberOfEmployees\n    productsCount\n    membersCount\n    projectsCount\n    feedCount\n    highlightsCount\n    newsworthyCount\n    usersCanAccessAccountPage\n    usersCanRequestContentTranslation\n    plan {\n      ...CompanyPlanFields\n    }\n    socialMedia {\n      linkedin\n      twitter\n      facebook\n      instagram\n      youtube\n    }\n    newsworthy {\n      description\n      title\n      favicon\n      siteName\n      url\n    }\n    products {\n      _id\n      status\n      slug\n      logo\n      name\n      description\n      link\n      governmentsUsingCount\n      projectsUsingCount\n      isDisruptor\n      enrichedProfile\n    }\n    cover {\n      original\n      repositioned\n    }\n    members {\n      _id\n      slug\n      role\n      firstName\n      fullName\n      jobTitle\n      avatar\n    }\n    relatedProjects {\n      _id\n      ...ProjectCardFields\n    }\n    pendingProductStackRequests {\n      _id\n      product {\n        _id\n        name\n        slug\n        logo\n      }\n      government {\n        _id\n        slug\n        logo\n        name\n        budget\n        currency\n        isInnovator\n        city {\n          _id\n          name\n          population\n          country\n          countryName\n        }\n      }\n      createdAt\n    }\n    groups {\n      _id\n      name\n      slug\n      logo\n      location\n      website\n      viewerCanDelete\n      viewerCanEdit\n      viewerIsOwner\n    }\n    actions {\n      _id\n      group {\n        _id\n        slug\n        name\n        logo\n      }\n      inviter {\n        ... on PendingUser {\n          _id\n          slug\n          fullName\n          avatar\n        }\n        ... on VendorUser {\n          _id\n          slug\n          fullName\n          avatar\n        }\n        ... on GovernmentUser {\n          _id\n          slug\n          fullName\n          avatar\n        }\n      }\n      createdAt\n    }\n    actionsCount\n    storiesCount\n    governmentConnectionsCount\n    governmentConnections(limit: 4) {\n      items {\n        _id\n        slug\n        logo\n        name\n        budget\n        currency\n        isInnovator\n        city {\n          _id\n          name\n          population\n          country\n          countryName\n        }\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n    resources {\n      ... on LinkResource {\n        url\n        title\n        addedAt\n      }\n      ... on DownloadResource {\n        url\n        title\n        filename\n        addedAt\n      }\n      ... on TextResource {\n        title\n        body\n        addedAt\n      }\n    }\n    enabledSharing\n    sharing {\n      stories\n      projects\n      products\n      resources\n      groups\n      governments\n      newsworthy\n      highlights\n      team\n    }\n    sponsorships {\n      name\n      logo\n      link\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ __webpack_exports__["Z"] = ((0,_apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .gql */ .Ps)(_templateObject(), _lib_queries_fragments_CompanyPlanFields__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _govlaunch_project__WEBPACK_IMPORTED_MODULE_2__/* .ProjectCardFieldsFragment */ .SS));


/***/ })

}]);